/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { Container, Row, Col } from "reactstrap";

// Redux
import { useSelector } from "react-redux";

import ConversationTable from "./components/ConversationTable/index";

import "./ManagerPanelThirdContainer.scss";

const index = ({ onExpand }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  return (
    <Container
      className={`container-panel ${mainTheme} w-100 px-1 m-2`}
      fluid={true}
    >
      <Row className="w-100 mx-0">
        <Col xs="12" sm="12" md="12" lg="12" xg="12">
          <ConversationTable onExpand={onExpand} />
        </Col>
      </Row>
    </Container>
  );
};

export default index;
